import Direction from './direction.js';
import { Side, SideParams } from './side.js';



const getDistanceNearSide = (originPos, pointPos) => pointPos-originPos;
const getDistanceFarSide = (originPos, pointPos) => originPos-pointPos;

const distanceFunctions = [];
distanceFunctions[Number(false)] = getDistanceNearSide;
distanceFunctions[Number(true)] = getDistanceFarSide;

class RegionLayerNearestPoints {
    constructor({ side, depth }) {
        this.width = null;
        this.height = null;

        this._side = side;
        this._depth = depth;

        this.nearestPoints = new Map();
    }

    setDepth(depth) {
        this._depth = depth;
    }

    calculate(mask, regionDistanceLayers) {
        const { direction, farSide } = SideParams[this._side];
        const distanceFunction = distanceFunctions[Number(farSide)];

        const { width, height } = mask;

        const originPos = this._side === Side.RIGHT ? width : this._side === Side.BOTTOM ? height : 0;

        this.width = width;
        this.height = height;

        this.nearestPoints.clear();

        for (let [id, { layers }] of regionDistanceLayers.regionData) {
            const nearestPoints = {
                distance: new Map(),
                position: new Map(),
            };

            this.nearestPoints.set(id, nearestPoints);

            let deepestLayer = layers.length-1;
            let minDepth = Math.min(deepestLayer, this._depth);

            let layer = layers[minDepth];

            switch (direction) {
                case Direction.HORIZONTAL:
                    for (let pos of layer) {
                        let x = pos%width, y = Math.floor(pos/width);

                        const oldDistance = nearestPoints.distance.has(y) ? nearestPoints.distance.get(y) : Infinity;
                        const distance = distanceFunction(originPos, x);

                        if (distance < oldDistance) {
                            nearestPoints.distance.set(y, distance);
                            nearestPoints.position.set(y, x);
                        }
                    }

                    break;

                case Direction.VERTICAL:
                    for (let pos of layer) {
                        let x = pos%width, y = Math.floor(pos/width);

                        const oldDistance = nearestPoints.distance.has(x) ? nearestPoints.distance.get(x) : Infinity;
                        const distance = distanceFunction(originPos, y);

                        if (distance < oldDistance) {
                            nearestPoints.distance.set(x, distance);
                            nearestPoints.position.set(x, y);
                        }
                    }

                    break;

                default:
                    throw new Error('invalid direction: '+direction);
            }
        }
    }

    getNearestPoint(id) {
        const nearestPoints = this.nearestPoints.get(id);

        if (nearestPoints) {
            let nearestTr = null, nearestDist = Infinity;

            for (let [posTr, distance] of nearestPoints.distance) {
                if (distance < nearestDist) {
                    nearestTr = posTr;
                    nearestDist = distance;
                }
            }

            return {
                transverse: nearestTr,
                longitudinal: nearestPoints.position.get(nearestTr),
                distance: nearestDist,
            };
        }
    }
}

RegionLayerNearestPoints.Side = Side;

export default RegionLayerNearestPoints;
export { RegionLayerNearestPoints, Side };
